// extracted by mini-css-extract-plugin
export default {"education-and-research-tags__box":"style_education-and-research-tags__box__F4k6E","education-and-research-tags__text":"style_education-and-research-tags__text__iJIiD"};